import './CalendarSelector.css';
import CalendarItem from "./CalendarItem";
import { AppstoreOutlined, BarsOutlined, PlusOutlined, SettingOutlined, CalendarOutlined } from '@ant-design/icons';
import { Button, Tooltip, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { CalendarService } from '../../services/calendar.api.client';
import { useCompany } from '../../contexts/CompanyContext';
import { Calendar } from '../../models/calendar/Calendar.model';
import { useModalCalendar } from '../../contexts/calendar/ModalCalendarContext.context';
import { useUpdater } from '../../contexts/calendar/UpdateCalendarSelect.context';
import { useCalendars } from '../../contexts/calendar/CalendarsContext.context';
import { useUser } from '../../contexts/UserContext';
import { useModalConfiguration } from '../../contexts/calendar/ModalConfigurationContext.context';
import { mapToCalendar } from '../../models/calendar/Event.model';

const { Title } = Typography;

export default function CalendarSelector() {
    const [isListView, setIsListView] = useState<boolean>(false);
    const {updater} = useUpdater();
    const {calendars, setCalendars} = useCalendars();
    const {company} = useCompany();
    const {setOptions:setOptionsModal} = useModalCalendar();
    const {setOptions} = useModalConfiguration();
    const {user} = useUser();
    
    useEffect(() => {
        if(!company.current.uid) return;
        CalendarService.getCalendarByCompany(company.current.uid)        
        .then((response)=>{
            const data: Calendar[] = response.calendarList || response;
            if(Array.isArray(data)){
                setCalendars(data.map(c => ({...c, ...mapToCalendar(c)})));
            }else{
                console.error('Error: Los calendarios no son un arreglo', data);
            }
        });

    }, [company.current.uid, updater]);


    const handlerCreateCalendar = () =>{
        setOptionsModal((prev)=>({
            ...prev,
            isopen:true,
            isCreating:true,
            isEditing:false,
            isConfiguration:false,
            id:''
        }))
    }

    return (<section className="calendar-selector">
                <header className="calendar-selector__header">
                    <Title level={4} style={{ margin: 0 }}>Seleccione un calendario</Title>
                    <div className="calendar-selector__buttons">
                        <Space size="small">
                            <Tooltip title={isListView ? "Vista de cuadrícula" : "Vista de lista"}>
                                <Button 
                                    icon={isListView ? <AppstoreOutlined/> : <BarsOutlined/>} 
                                    onClick={() => setIsListView(!isListView)} 
                                /> 
                            </Tooltip>
                            {user.permissions?.views?.includes("calendar.calendars.main.view.create_calendar") && (
                                <Tooltip title="Nuevo calendario">
                                    <Button type="primary" icon={<PlusOutlined/>} onClick={()=> handlerCreateCalendar()} />
                                </Tooltip>
                            )}
                            { user.permissions?.views?.includes("calendar.calendars.main.options.view.configuration_users") && 
                            <Tooltip title="Configuración de permisos">
                                <Button 
                                    icon={<SettingOutlined />} 
                                    onClick={() => 
                                        setOptions((prev) => ({
                                            ...prev,
                                            isopen: true,
                                            id: '',
                                            isConfigUser:true,
                                            width:"600px"
                                        }))
                                    }
                                /> 
                            </Tooltip>}
                        </Space>
                    </div>
                </header>
                {calendars.length === 0 ? (
                    <div className="calendar-selector__empty">
                        <CalendarOutlined className="calendar-selector__empty-icon" />
                        <p>No hay calendarios disponibles. Crea uno nuevo para comenzar.</p>
                    </div>
                ) : (
                    <main className={isListView ? 'calendar-selector__main_v' : 'calendar-selector__main_h'}>
                        {
                            calendars.map((item, index) => (
                                <CalendarItem key={item.id || index} calendar={item} />
                            ))
                        }
                    </main>
                )}
            </section>);
}